<template>
  <FilterMultiChip
    is-text
    :label-mode="labelMode"
    icon="tag"
    :label="$t('search-filters.labels')"
    :items="items"
    :value="value || []"
    @change="$emit('change', $event)"
  >
    <template #option="{ option }">
      <span class="labels-chip__opt">
        <BaseTag :background="option.color">{{ option.text }}</BaseTag>
      </span>
    </template>
  </FilterMultiChip>
</template>

<script>
import BaseTag from '@/components/base/BaseTag';
import FilterMultiChip from '@/components/filters/FilterMultiChip';
import { LABEL_MODE } from '@/components/filters/label-mode';

/**
 * Opportunity-labels dimension chip. Presentational: `:value` (array of label ids) + `:labels`
 * (the tenant's label list the page owns) in, `change` out. Multi-select, sorted by name, each
 * option rendered as the label's colored tag so it reads like the labels column.
 */
export default {
  name: 'LabelsChip',
  components: { BaseTag, FilterMultiChip },
  props: {
    value: { type: Array, default: () => [] },
    labels: { type: Array, default: () => [] },
  },
  computed: {
    labelMode: () => LABEL_MODE.COLLAPSE,
    items() {
      return (this.labels || [])
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((label) => ({ value: label.id, text: label.name, color: label.color }));
    },
  },
};
</script>

<style lang="scss">
.labels-chip__opt {
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  margin-left: 10px;
}
</style>
